import { render, staticRenderFns } from "./ModifyChannelPopup.vue?vue&type=template&id=4cfae3ec&"
import script from "./ModifyChannelPopup.vue?vue&type=script&lang=js&"
export * from "./ModifyChannelPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports